/* eslint-disable no-shadow */

export const enum LayoutSize {
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
  XXL = 'XXL',
}

export const LayoutSizeScale = {
  [LayoutSize.S]: 0,
  [LayoutSize.M]: 1,
  [LayoutSize.L]: 2,
  [LayoutSize.XL]: 3,
  [LayoutSize.XXL]: 4,
};

export const getLayoutSize = (width: number) => {
  if (width >= 1366) {
    return LayoutSize.XXL;
  }
  if (width >= 1024) {
    return LayoutSize.XL;
  }
  if (width >= 640) {
    return LayoutSize.L;
  }
  if (width >= 480) {
    return LayoutSize.M;
  }

  return LayoutSize.S;
};
